import { Injectable } from '@angular/core';
import { Bounds } from './data';
import * as store from 'store';

export interface NamedExtent extends Bounds {
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExtentsService {
  private _storageKey:string;
  constructor() { }

  private _extents: NamedExtent[] = [];
  private _currentExtent: NamedExtent = null;

  set storageKey(key: string) {
    this._storageKey = key;
    const storedExtents = store.get(key, []);
    if (storedExtents) {
      this._extents = storedExtents;
    }
  }

  saveExtents() {
    if (this._storageKey) {
      store.set(this._storageKey, this._extents);
    }
  }

  addExtent(extent: NamedExtent) {
    this._extents.push(extent);
    this.saveExtents();
  }

  // saveCurrentExtent() {
  //   if (this._currentExtent) {
  //     this._extents.push(this._currentExtent);
  //   }
  // }

  deleteExtent(extent: NamedExtent) {
    const index = this._extents.indexOf(extent);
    if (index > -1) {
      this._extents.splice(index, 1);
    }
    this.saveExtents();
  }

  get extents() {
    return this._extents.slice();
  }

  get currentExtent() {
    return this._currentExtent;
  }
  set currentExtent(extent: NamedExtent) {
    this._currentExtent = extent;
  }
}
